import React, { useRef, useState } from "react";
import { api } from "@/lib/auth";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";

export default function ImageUpload({ value, onChange, label = "Image URL", testId }) {
  const [uploading, setUploading] = useState(false);
  const [dragging, setDragging] = useState(false);
  const ref = useRef();

  const upload = async (file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) { toast.error("Only images allowed"); return; }
    setUploading(true);
    const fd = new FormData(); fd.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const url = data.url;
      onChange(url);
      toast.success("Uploaded");
    } catch (e) { toast.error(e.response?.data?.detail || "Upload failed"); }
    finally { setUploading(false); }
  };

  return (
    <div>
      <label className="eyebrow block mb-1">{label}</label>
      <div className="flex gap-2 items-start">
        <input type="text" value={value || ""} onChange={e => onChange(e.target.value)}
          placeholder="Paste URL or drop image →"
          data-testid={testId || undefined}
          className="flex-1 bg-black border border-white/10 px-3 py-2 text-sm focus:border-red-600 outline-none" />
        <div
          onDragOver={e => { e.preventDefault(); setDragging(true); }}
          onDragLeave={() => setDragging(false)}
          onDrop={e => { e.preventDefault(); setDragging(false); upload(e.dataTransfer.files?.[0]); }}
          onClick={() => ref.current?.click()}
          className={`w-24 h-10 border ${dragging ? "border-red-600 bg-red-600/10" : "border-white/10"} grid place-items-center cursor-pointer hover:border-red-600`}
          data-testid={testId ? `${testId}-upload` : "img-upload"}
        >
          {uploading ? <Loader2 className="animate-spin" size={14}/> : <div className="flex items-center gap-1 text-xs text-zinc-400"><Upload size={12}/>Upload</div>}
        </div>
        <input type="file" accept="image/*" ref={ref} className="hidden" onChange={e => upload(e.target.files?.[0])} />
      </div>
      {value && typeof value === "string" && value.startsWith("http") && (
        <img src={value} alt="" className="mt-2 h-20 object-cover border border-white/10" />
      )}
    </div>
  );
}
